import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-component-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.mypage/view.scss */
/* src/app/component.mypage/view.scss: no such file or directory */`],
})
export class ComponentMypageComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public user: any = null;

    public form: any = {
        phone: ''
    };

    public pwd: any = {
        current: '',
        next: '',
        repeat: ''
    };

    // public alert: any;  // 제거

    public async ngOnInit() {
        await this.service.init();
        this.title.setTitle('마이페이지');

        // 로그인 요구 (비로그인 접근 차단)
        const allowed = await this.service.auth.allow(true, '/ui/mypage');
        if (!allowed) return;

        // 내 정보 로드
        const { code, data } = await wiz.call('get');
        if (code === 200) {
            this.user = data;
            this.form.phone = data?.phone || '';
        } else {
            await this.notifyError('내 정보를 불러오지 못했습니다.');
        }

        await this.service.render();
    }

    private isValidPhone(v: string): boolean {
        const re = /^(0\d{1,2}-\d{3,4}-\d{4})$/;
        return re.test(v);
    }

    // 알림 헬퍼 (서비스가 없을 때 window.alert로 폴백)
    private async notifySuccess(msg: string) {
        if (this.service?.alert?.success) return await this.service.alert.success(msg);
        window.alert(msg);
    }
    private async notifyError(msg: string) {
        if (this.service?.alert?.error) return await this.service.alert.error(msg);
        window.alert(msg);
    }
    private async notifyWarning(msg: string) {
        if (this.service?.alert?.warning) return await this.service.alert.warning(msg);
        window.alert(msg);
    }

    public async savePhone() {
        const phone = (this.form.phone || '').trim();

        if (!phone) return await this.notifyError('휴대전화 번호를 입력해주세요.');
        if (!this.isValidPhone(phone)) {
            return await this.notifyError('휴대전화 형식을 확인해주세요. 예) 010-1234-5678');
        }

        const { code, data } = await wiz.call('update_phone', { phone });
        if (code === 200) {
            await this.notifySuccess('휴대전화 번호가 변경되었습니다.');
            this.user.phone = phone;
        } else {
            await this.notifyError(data || '휴대전화 변경에 실패했습니다.');
        }
        await this.service.render();
    }

    public async changePassword() {
        const current = (this.pwd.current || '').trim();
        const next = (this.pwd.next || '').trim();
        const repeat = (this.pwd.repeat || '').trim();

        if (!current) return await this.notifyError('현재 비밀번호를 입력해주세요.');
        if (!next) return await this.notifyError('새 비밀번호를 입력해주세요.');
        if (next.length < 8) return await this.notifyError('8글자 이상의 비밀번호를 설정해주세요.');
        if (next !== repeat) return await this.notifyError('새 비밀번호가 일치하지 않습니다.');

        const current_h = this.service.auth.hash(current);
        const next_h = this.service.auth.hash(next);

        // 로딩 표시 (필요 시)
        const { code, data } = await wiz.call('update_password', {
            current_password: current_h,
            new_password: next_h
        });

        if (code === 200) {
            // 사용자에게 확실히 인지시킨 후 로그아웃 페이지로 이동
            alert('비밀번호가 성공적으로 변경되었습니다. 보안을 위해 다시 로그인해주세요.');
            location.href = '/auth/logout';
        } else {
            await this.notifyError(data || '비밀번호 변경에 실패했습니다.');
        }

        await this.service.render();
    }
}

export default ComponentMypageComponent;